import R from 'ramda'

const ADD_TIMED_THREAD_WIDGET_TYPE = 'ADD_TIMED_THREAD_ACTIVITY'
const ADD_TIMED_THREAD_DISPLAY_TYPE = 'Add Timed Thread Activity'

const isAddTimedWidgetType = R.propEq('type', ADD_TIMED_THREAD_WIDGET_TYPE)

const convertAddTimedWidgetToForm = R.applySpec({
  type: R.always(ADD_TIMED_THREAD_DISPLAY_TYPE)
})

export { isAddTimedWidgetType, convertAddTimedWidgetToForm }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/add-timed-thread-activity.js